export default __webpack_public_path__ + "static/media/NO-IMAGE-AVAILABLE-2.46fc37dc.png";